module.exports = __webpack_public_path__ + "img/wcyg-concierge.15cb9754.svg";